/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import isEqual from 'lodash-es/isEqual'

import FontNumber from '../../../components/common/FontNumber'
import ScrollableTable from '../../../components/exchange/ScrollableTable'
import Change from '../../../components/exchange/Change'
import LoadingShade from '../../../components/common/LoadingShade'
import TradingPairFilter from '../../../components/exchange/TradePairFilter'
import Icon from '../../../components/common/Icon'

import { floor, formatNumber } from '../../../utils/number'
import { setCurrentTrade, setAmount, setCurrentPrice } from '../../../redux/exchange/action'
import { getTradeHistoryQS, setTradeHistory } from '../../../redux/trade/action'
import { getDepth } from '../../../redux/orderbooks/action'
import { setFavorites } from '../../../redux/tradePairs/action'

import { withI18n } from '../../../i18n/util'
import isElectron from '../../../utils/isElectron'
import { getInitialFavorites } from '../../../utils/favorites'

import {
  PriceAlign,
  Wrapper,
  FavoriteButton,
  SelectedTradePairItem,
  TradePairContent,
  TradePairHD,
  TradePairInner,
  TradePairItem,
  TradePairText,
  Volume,
} from './styled'
import { withFilteredPairs } from './withFilteredPairs'
import { TOKEN_TYPE_BEP8, TOKEN_TYPE_BEP2, getTokenType } from 'utils/tokenTypes'

class TradingPair extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    currentTrade: PropTypes.string,
    pairs: PropTypes.array,
    symbolTickers: PropTypes.array,
    lastTrade: PropTypes.object,
    flexGrow: PropTypes.number,
    isFetchingMarkets: PropTypes.bool,
    formatI18nText: PropTypes.func,
    tabs: PropTypes.array,
    favorites: PropTypes.object,
    history: PropTypes.object.isRequired,
  }

  static defaultProps = {
    dispatch: () => {},
    currentTrade: '',
    pairs: [],
    symbolTickers: [],
    tabs: [],
    lastTrade: {},
    flexGrow: 1,
    isFetchingMarkets: false,
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      togglePanel: 'change',
      searchKeyWord: '',
      scTradePairsPoped: false,
      altsTradePairsPoped: false,
      tradePairs: [
        { name: 'BNB', selected: true },
        { name: 'BTC.B', selected: false },
        { name: 'USDT.B', selected: false },
      ],
      sortType: 'sort_desc',
      sortDataIndex: '',
      sortFunc: (a, b, sortType) => {
        if (sortType === 'sort_desc') {
          return parseFloat(b.volume) - parseFloat(a.volume)
        } else {
          return parseFloat(a.volume) - parseFloat(b.volume)
        }
      },
    }
  }

  componentDidMount() {
    const { dispatch } = this.props
    this._getTradePairs()
    const favorites = getInitialFavorites()
    dispatch(setFavorites(favorites))
  }

  componentDidUpdate(prevProps) {
    const { pairs } = this.props
    if (prevProps.pairs.length !== pairs.length && !isEqual(pairs, prevProps.pairs)) {
      this._getTradePairs()
    }
  }

  _getTradePairs = () => {
    const { currentTrade, tabs, pairs } = this.props

    //Bep8 only support BNB and BUSD markets
    let filterdTabs = tabs
    if (pairs[0]?.tokenType === TOKEN_TYPE_BEP8) {
      filterdTabs = ['favorites', 'BNB', 'FIATⓈ']
    }

    const currentQuote = currentTrade.split('_')[1] || 'BNB'
    const pair = pairs.find(item => item.quote_asset_symbol === currentQuote) || {}
    const tradePairs = filterdTabs.map(tab => ({
      name: tab,
      selected: pair.tab === tab || pair.tab?.includes(tab),
    }))

    this.setState({ tradePairs })
  }

  _selectTradePair = tradePair => {
    const { tradePairs } = this.state
    tradePairs.forEach(item => {
      if (item.isMultiValue) {
        const isExist = item.items.find(i => i.name === tradePair)
        if (isExist) {
          item.selected = true
        } else {
          item.selected = false
        }
      } else if (item.name === tradePair) {
        item.selected = true
      } else {
        item.selected = false
      }
    })
    this.forceUpdate()
  }

  _splitTrade = newTrade => {
    const result = newTrade.split('_')
    return { baseAsset: result[0], quoteAsset: result[1] }
  }

  _selectCurrentTrade = item => {
    const { dispatch, currentTrade, locale, history } = this.props
    const newTrade = item.key.replace('/', '_')
    const tokenType = getTokenType()
    if (currentTrade === newTrade) return
    const asset = this._splitTrade(newTrade)
    const tradeParams = {
      offset: 0,
      limit: 50,
      symbol: `${asset.baseAsset}_${asset.quoteAsset}`,
      end: new Date().getTime(),
    }
    dispatch(setCurrentTrade(newTrade))
    dispatch(getDepth({ symbol: newTrade, limit: 20 }))
    dispatch(setTradeHistory({ trade: [] }))
    dispatch(setCurrentPrice(item.Price))
    dispatch(setAmount({ buyAmount: '', sellAmount: '' }))
    const newUrl =
      tokenType === TOKEN_TYPE_BEP2
        ? `/${locale}/trade/${asset.baseAsset}_${asset.quoteAsset}`
        : `/${locale}/trade/mini/${asset.baseAsset}_${asset.quoteAsset}`

    if (!isElectron()) {
      window.history.replaceState({ baseAsset: asset.baseAsset }, '', newUrl)
    } else {
      history.push(newUrl)
    }
  }

  _buildPairs = () => {
    const { pairs, symbolTickers, lastTrade, favorites } = this.props
    const { searchKeyWord, tradePairs } = this.state
    const selectedTradePair = tradePairs.find(p => p.selected) || {}
    let filteredPairs = pairs.filter(
      item =>
        item.base_asset_symbol.toUpperCase().includes(searchKeyWord) &&
        item.tab.includes(selectedTradePair.name)
    )

    if (selectedTradePair.name === 'favorites') {
      filteredPairs = pairs.filter(p =>
        favorites?.find(
          f =>
            f === `${p.base_asset_symbol}/${p.quote_asset_symbol}` &&
            (p.base_asset_symbol.toUpperCase().includes(searchKeyWord) ||
              p.quote_asset_symbol.toUpperCase().includes(searchKeyWord))
        )
      )
    }

    let result = filteredPairs.map(p => {
      const pair = {
        Pair: p.base_asset_symbol ? `${p.base_asset_displayname}/${p.quote_asset_displayname}` : '',
      }
      const ticker =
        symbolTickers.find(
          item => item.symbol === `${p.base_asset_symbol}_${p.quote_asset_symbol}`
        ) || {}
      pair.Price =
        lastTrade.s === `${p.base_asset_symbol}_${p.quote_asset_symbol}`
          ? lastTrade.p
          : ticker.price || p.price

      pair.volume = ticker.volume ? parseFloat(ticker.volume, 10) : 0
      pair.change = ticker.priceChangePercent ? ticker.priceChangePercent : 0

      pair.key = p.base_asset_symbol ? `${p.base_asset_symbol}/${p.quote_asset_symbol}` : ''

      return pair
    })

    const { sortType, sortFunc } = this.state

    result = result.sort((a, b) => sortFunc(a, b, sortType))

    result = this._setSameSymbolNameFlag(result)

    return result
  }

  _setSameSymbolNameFlag = dataArr => {
    const result = []
    dataArr.forEach(item => {
      const existPair = dataArr
        .filter(fd => fd.key !== item.key)
        .find(d => d.Pair.split('-')[0] === item.Pair.split('-')[0])
      if (existPair) {
        item.hasSameName = true
      }

      result.push(item)
    })
    return result
  }

  _getTickerSize = trade => {
    const { currentTrade, pairs } = this.props
    trade = trade || currentTrade
    const pair =
      pairs.find(item => `${item.base_asset_symbol}_${item.quote_asset_symbol}` === trade) || {}
    return pair.tick_size
  }

  _filterParamsChange = (togglePanel, searchKeyWord) => {
    this.setState({ togglePanel, searchKeyWord })
  }

  _getPrice = item => {
    const trade = item.key.replace('/', '_')
    const tickSize = this._getTickerSize(trade)
    const tickDps = Math.abs(Math.log10(tickSize))
    return <PriceAlign>{floor(item.Price, tickDps)}</PriceAlign>
  }

  _addFavorite = item => {
    const { favorites, dispatch } = this.props
    if (!favorites?.find(f => f === item.key)) {
      favorites?.push(item.key)
    } else {
      for (let i = 0, len = favorites?.length; i < len; i++) {
        if (favorites[i] === item.key) {
          favorites?.splice(i, 1)
        }
      }
    }

    dispatch(setFavorites(favorites))
  }

  _buildColumns = () => {
    const { togglePanel } = this.state
    const { formatI18nText } = this.props

    const columns = [
      {
        title: formatI18nText('exchange.tradingPair.pair'),
        dataIndex: 'Pair',
        headerAlign: 'left',
        sorter: true,
        key: 'Pair',
        width: '40%',
        render: item => {
          const { favorites, address } = this.props
          let type = 'staroutlined'
          if (favorites?.find(f => f === item.key)) {
            type = 'starfilled'
          }

          return (
            <TradePairText>
              <FavoriteButton
                onClick={ev => {
                  ev.stopPropagation()
                  this._addFavorite(item)
                }}
              >
                <Icon type={type} color="#f0b90b" size={12} />
              </FavoriteButton>
              <span>{item.hasSameName ? item.key : item.Pair ? item.Pair : ''}</span>
            </TradePairText>
          )
          // if (item.hasSameName) {
          //   return <TradePairText>{item.Pair}</TradePairText>
          // } else {
          //   return <TradePairText>{item.Pair ? item.Pair : ''}</TradePairText>
          // }
        },
        sortFunc: (a, b, sortType) => {
          if (sortType === 'sort_asc') {
            return a.Pair.localeCompare(b.Pair)
          } else {
            return b.Pair.localeCompare(a.Pair)
          }
        },
      },
      {
        title: formatI18nText('exchange.tradingPair.price'),
        dataIndex: 'Price',
        headerAlign: 'right',
        sorter: true,
        key: 'Price',
        width: '20%',
        render: item => this._getPrice(item),
        sortFunc: (a, b, sortType) => {
          if (sortType === 'sort_desc') {
            return parseFloat(b.Price) - parseFloat(a.Price)
          } else {
            return parseFloat(a.Price) - parseFloat(b.Price)
          }
        },
      },
      {
        title: formatI18nText(`exchange.tradingPair.${togglePanel}`),
        dataIndex: togglePanel,
        headerAlign: 'right',
        sorter: true,
        key: togglePanel,
        width: '40%',
        render: item => {
          if (togglePanel === 'volume') {
            return (
              <Volume>
                <FontNumber value={formatNumber(item[togglePanel], 2)} />
              </Volume>
            )
          }
          return <Change change={item[togglePanel]} />
        },
        sortFunc: (a, b, sortType) => {
          if (sortType === 'sort_desc') {
            return parseFloat(b[togglePanel]) - parseFloat(a[togglePanel])
          } else {
            return parseFloat(a[togglePanel]) - parseFloat(b[togglePanel])
          }
        },
      },
    ]
    return columns
  }

  _buildRend = () => {
    const { tradePairs } = this.state
    const result = []
    tradePairs.forEach(p => {
      if (!p.category) {
        result.push(p)
      }
    })

    const mutltiPairs = tradePairs.filter(p => p.category)
    mutltiPairs.forEach(pair => {
      const existCategory = result.find(p => p.category === pair.category)
      if (!existCategory) {
        result.push({
          category: pair.category,
          isMultiValue: true,
          items: [pair],
        })
      } else {
        existCategory.items.push(pair)
      }
    })
    return result
  }

  _sortTradingPairs = (sortType, sortDataIndex, sortFunc) => {
    this.setState({ sortType, sortDataIndex, sortFunc })
  }

  render() {
    const { pairs, flexGrow, isFetchingMarkets } = this.props
    const { tradePairs } = this.state

    const dataSource = this._buildPairs()

    const columns = this._buildColumns()

    const tradeParisItems = tradePairs.map(item => {
      if (item.selected) {
        return (
          <SelectedTradePairItem key={item.name}>
            {item.name === 'favorites' ? <Icon type="starfilled" /> : item.name}
          </SelectedTradePairItem>
        )
      }
      return (
        <TradePairItem
          key={item.name}
          onClick={() => {
            this._selectTradePair(item.name)
          }}
        >
          {item.name === 'favorites' ? <Icon type="starfilled" /> : item.name}
        </TradePairItem>
      )
    })

    return (
      <Wrapper flexGrow={flexGrow}>
        <TradePairHD>
          <TradePairInner>{tradeParisItems}</TradePairInner>
        </TradePairHD>
        <TradingPairFilter onChange={this._filterParamsChange} />
        <TradePairContent>
          <ScrollableTable
            columns={columns}
            dataSource={dataSource}
            onRowClick={this._selectCurrentTrade}
            isFixedHeader={true}
            sort={this._sortTradingPairs}
          />
          {pairs.length === 0 && isFetchingMarkets && <LoadingShade />}
        </TradePairContent>
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  exchange: { currentTrade },
  tradePairs: { isFetchingMarkets, tabs, favorites },
  tickers: { symbolTickers },
  trade: { tradeHistory },
}) => ({
  symbolTickers,
  currentTrade,
  isFetchingMarkets,
  tabs,
  favorites,
  lastTrade: tradeHistory && tradeHistory.trade[0],
})

export default withFilteredPairs(withI18n(connect(mapStateToProps)(withRouter(TradingPair))))
